import { IFormSection } from "../../../model/form/FormSection";

const FormSectionNestedList = (
  formSections: IFormSection[],
  subsections = formSections,
  topLevel = true
) => {
  let formSectionNestedList: IFormSection[] = [];
  subsections.forEach(async (section: IFormSection) => {
    if (!(topLevel && section.formSectionId)) {
      let childSections: IFormSection[] = [];
      childSections = formSections.filter(
        (formSection: IFormSection) => formSection.formSectionId === section.id
      );
      subsections = FormSectionNestedList(formSections, childSections, false);
      if (subsections) {
        section.subsections = subsections;
        formSectionNestedList.push(section);
      }
    }
  });
  return formSectionNestedList;
};

export default FormSectionNestedList;
